var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},_vm._l((_vm.weekdays),function(day,index){return _c('b-checkbox',{key:index,attrs:{"native-value":index,"type":"is-info"},model:{value:(_vm.days),callback:function ($$v) {_vm.days=$$v},expression:"days"}},[_vm._v(" "+_vm._s(_vm.$t(day))+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }